import YourDetailsSummary from './YourDetailsSummary';

export default YourDetailsSummary;
